import { FaClipboardCheck, FaChalkboardTeacher, FaHospitalSymbol, FaLaptopMedical, FaSearch } from 'react-icons/fa';

const services = [
  {
    title: 'Strengthen Institutional capacity for patient safety governance and improvement',
    description: '',
    icon: <FaClipboardCheck className="text-green-200 text-6xl" />,
  },
  {
    title: 'Provide an integrated digital ecosystem for measurement, learning, and reporting',
    description: '',
    icon: <FaChalkboardTeacher className="text-green-200 text-6xl" />,
  },
  {
    title: 'Foster a culture of transparency, learning, and accountability in healthcare',
    description: '',
    icon: <FaHospitalSymbol className="text-green-200 text-6xl" />,
  },
  {
    title: 'Enable benchmarking and recognition for organizations demonstrating excellence',
    description: '',
    icon: <FaLaptopMedical className="text-green-200 text-6xl" />,
  },
  {
    title: 'Promote collaborative learning and sharing of best practices in patient safety',
    description: '',
    icon: <FaSearch className="text-green-200 text-6xl" />,
  },
];

export default function WhatWeDoComponent() {
  return (
    <section className="py-12 px-4 md:px-8 lg:px-16 bg-white dark:bg-gray-100">
      <h2 className="text-3xl font-bold text-center mb-10 text-gray-800 dark:text-dark">What We Do:</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center p-6 border rounded-3xl shadow-sm bg-gray-50 dark:bg-blue-900 hover:shadow-md transition"
          >
            {service.icon}
            <h3 className="mt-4 text-xl font-semibold text-gray-700 dark:text-white">{service.title}</h3>
            <p className="mt-2 text-gray-600 dark:text-gray-300">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
